export default "__VITE_ASSET__z4B9CEP4__"